import { defineMessages } from 'react-intl';

const messages = defineMessages({
  errorHeader: {
    id: 'App.TextingTab.ErrorHeader',
    defaultMessage: 'Error',
  },
  failedToLoadHouseholdMembersErrorMsg: {
    id: 'App.TextingTab.FailedToLoadHouseholdMembersErrorMsg',
    defaultMessage: 'Failed to load household members.',
  },
  failedToLoadConversationsErrorMsg: {
    id: 'App.TextingTab.failedToLoadConversationsErrorMsg',
    defaultMessage: 'Failed to load conversations.',
  },
  failedToLoadMessagesErrorMsg: {
    id: 'App.TextingTab.FailedToLoadMessagesErrorMsg',
    defaultMessage: 'Failed to load messages.',
  },
  failedToSendMessageErrorMsg: {
    id: 'App.TextingTab.FailedToSendMessageErrorMsg',
    defaultMessage: 'Unable to send message, please try again later.',
  },
  failedToLoadCommunicationPreferencesErrorMsg: {
    id: 'App.TextingTab.FailedToLoadCommunicationPreferencesErrorMsg',
    defaultMessage: 'Failed to load communication preferences.',
  },
  failedToLoadLeslieErrorMsg: {
    id: 'App.TextingTab.FailedToLoadLeslieErrorMsg',
    defaultMessage: "Failed to load Leslie's status for this household.",
  },
  failedToUpdateLeslieErrorMsg: {
    id: 'App.TextingTab.FailedToUpdateLeslieErrorMsg',
    defaultMessage: 'Failed to update Leslie for this household.',
  },
  failedToResolveLeslieHelpErrorMsg: {
    id: 'App.TextingTab.FailedToResolveLeslieHelpErrorMsg',
    defaultMessage:
      "Your reply was sent, but Leslie's help request could not be resolved. Please try again.",
  },
  userNoLongerOptedInErrorMsg: {
    id: 'App.TextingTab.UserNoLongerOptedInErrorMsg',
    defaultMessage: 'The recipient has opted out of receiving messages.',
  },
});

export default messages;
